<main class="signed-out" aria-labelledby="signed-out-title">
  <section class="signed-out__content">
    <h1 id="signed-out-title">You are now signed out</h1>
    <a class="signed-out__link" [href]="signInUrl">Return to Sign In</a>
  </section>
</main>
